import { render } from "./WpeButtonGroup.vue?vue&type=template&id=52c697da"
import script from "./WpeButtonGroup.vue?vue&type=script&lang=js"
export * from "./WpeButtonGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/controls/WpeButtonGroup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52c697da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52c697da', __exports__)) {
    api.reload('52c697da', __exports__)
  }
  
  module.hot.accept("./WpeButtonGroup.vue?vue&type=template&id=52c697da", () => {
    api.rerender('52c697da', render)
  })

}


export default __exports__